<template>
  <div class="bt-map" id="btMap">
    <div class="content" ref="mapBox">
      <BorderMapComponent
        :areaCode="areaCode"
        :baseConfig="baseConfig"
        :bubbleData="bubbleData"
        :heatMarkConfig="heatMarkConfig"
        :heatMarkData="heatMarkData"
        :legendConf="legendConf"
        :mapData="mapData"
        :itemList="itemList"
        :mask="mask"
        :drillDown="drillDown"
        @listeningMapCilick="listeningMapCilick"
        @listeningMouseHovering="listeningMouseHovering"
      ></BorderMapComponent>
    </div>
  </div>
</template>
<script>
import BorderMapComponent from "./BorderMapComponent.vue";

export default {
  name: "btMap",
  props: {
    heatMarkData: {
      type: Object,
      default() {
        return {};
      }
    },
    areaCode: {
      type: String,
      default: ""
    },
    legendConf: {
      type: Array,
      default() {
        return [];
      }
    },
    itemList: {
      type: Array,
      default() {
        return [];
      }
    },
    mapData: {
      type: Array,
      default() {
        return [];
      }
    },
    mask: {
      type: Number,
      default: 1
    },
    drillDown: {
      type: Number,
      default: 1
    }
  },
  computed: {
    baseConfig() {
      return {
        width: this.boxWidth, // 组件宽度
        height: this.boxHeight // 组件高度
      };
    }
  },
  data: function() {
    return {
      boxWidth: 0,
      boxHeight: 0,
      heatMarkConfig: {
        minHeight: 20, // 最小高度，默认0,最小值对应的高度
        maxHeight: 80, // 最大高度，默认100，最大值对应的高度
        // 圆柱和图例配色
        colors: [
          {
            min: 80,
            max: 100,
            color: "#DA221A"
          },
          {
            min: 60,
            max: 80,
            color: "#FF852F"
          },
          {
            min: 50,
            max: 60,
            color: "#F5E047"
          },
          {
            min: 30,
            max: 50,
            color: "#6BF15c"
          },
          {
            min: 0,
            max: 30,
            color: "#34B7ED"
          }
        ]
      },
      bubbleData: {
        // 标牌数据
        // touristVolume: '200万',   // 游客量
        // visitors: '300万',        // 游客人次
        // inflowVolume: '50万',     // 流入量
        // outflowVolume: '48万'     // 流出量
      }
    };
  },
  methods: {
    // 地图点击和返回回调
    listeningMapCilick(adcode) {
      // console.log(adcode);
    },
    // 鼠标悬停回调，鼠标移出地图区域adcode为undefined
    listeningMouseHovering(adcode) {
      // console.log(adcode);
      // this.bubbleData = {
      //   // 标牌数据
      //   touristVolume: Math.round(Math.random() * 2000) + "万",
      //   visitors: Math.round(Math.random() * 2000) + "万",
      //   inflowVolume: Math.round(Math.random() * 2000) + "万",
      //   outflowVolume: Math.round(Math.random() * 2000) + "万"
      // };

      // 遍历拿标牌
      this.bubbleData = false;
      for (let i = 0; i < this.mapData.length; i++) {
        if (this.mapData[i].code == adcode) {
          this.bubbleData = this.mapData[i];
        }
      }
    },
    reset() {
      this.boxWidth = this.$refs.mapBox.offsetWidth;
      this.boxHeight = this.$refs.mapBox.offsetHeight;
    }
  },
  components: {
    BorderMapComponent
  },
  mounted() {
    this.$nextTick(() => {
      this.reset();
      console.log(this.boxWidth);
      console.log(this.boxHeight);
      window.addEventListener("resize", this.reset);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.reset);
  }
};
</script>
<style scoped lang="less">
.bt-map {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  .content {
    width: 100%;
    height: 100%;
  }
}
</style>
